import React from 'react';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';

import AdvWorkflow from '../AdvWorkflow/AdvWorkflowContainer';
import DoYouHavePension from './Steps/DoYouHavePensionContainer';
import PensionsOverview from './Steps/PensionsOverviewContainer';

const PensionWorkflowView = ({ branch, workflowId }) => (
  <AdvWorkflow
    branch={branch}
    workflowId={workflowId}
    steps={[DoYouHavePension, PensionsOverview]}
  />
);

PensionWorkflowView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
};

export default PensionWorkflowView;
